<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h3>Exporty</h3>
        
        <h4 class="mt-3">XLSX (Excel):</h4>
        <p>Určeno pro pořadatele a oddíly k evidenci přihlášených.</p>
        <ul>
            <li>Seznam přihlášených - <code>https://rob-is.cz/export/?type=xlsx&event_id=<span class="blue">robis ID soutěže</span></code></li>
        </ul>
        <h4 class="mt-3">DOCX (Word):</h4>
        <p></p>
        <ul>
            <li>Protokol soutěže - <code>https://rob-is.cz/export/?type=docx&event_id=<span class="blue">robis ID soutežě</span></code></li>
            <li>Zpráva delegáta - <code>https://rob-is.cz/export/?type=docx&name=delegate_report&event_id=<span class="blue">robis ID soutěže</span></code></li>
        </ul>
        <h4>CSV:</h4>
        <ul>
            <li><a :href="`${BaseUrl}/export/?type=csv&name=robis_accounts`">Seznam závodníků s čísly čipů a indexy</a></li>
            <li>Seznam přihlášených Matula - <code>https://rob-is.cz/export/?type=csv&name=entry_matula&event_id=<span class="blue">robis ID soutežě</span></code></li>
            <li>Seznam přihlášených ARDF Manager - <code>https://rob-is.cz/export/?type=csv&name=entry_ardf_manager&event_id=<span class="blue">robis ID soutežě</span></code></li>
            <li>Seznam přihlášených OCM Manager - <code>https://rob-is.cz/export/?type=csv&name=entry_ocm&event_id=<span class="blue">robis ID soutežě</span></code></li>
            <li>Seznam přihlášených FjwW - <code>https://rob-is.cz/export/?type=csv&name=entry_fjww&event_id=<span class="blue">robis ID soutežě</span></code></li>
            <li>Startovní listina - <code>https://rob-is.cz/export/?type=csv&name=startlist&race_id=<span class="blue">robis ID etapy</span></code></li>

        </ul>

        <h4>XML IOF 3.0 + ARDF:</h4>
        <ul>
            <li>Seznam přihlášených - <code>https://rob-is.cz/export/?type=xml&name=entry_xml&event_id=<span class="blue">robis ID soutěže</span></code></li>
            <li>Startovka - <code>https://rob-is.cz/export/?type=xml&name=startlist&race_id=<span class="blue">robis ID etapy</span></code></li>
            <!-- <li>Výsledky IOF - <code>https://rob-is.cz/export/?type=xml&name=results&race_id=<span class="blue">robis ID etapy</span></code></li> -->
            <li>Výsledky - <code>https://rob-is.cz/export/?type=xml&name=results&race_id=<span class="blue">robis ID etapy</span></code></li>
        </ul>

        <h4>ARDF JSON (přihlášky, startovka, výsledky):</h4>
        <ul>
            <li>Etapa - <code>https://rob-is.cz/api/?type=json&name=race&race_id=<span class="blue">robis ID etapy</span></code></li>
            <li>Etapy v soutěži - <code>https://rob-is.cz/export/?type=json&name=entry_json&event_id=<span class="blue">robis ID soutěže</span></code></li>
        </ul>

        <h4>PDF:</h4>
        <ul>
            <li>Startovní listina po časech - <code>https://rob-is.cz/export/?type=pdf&name=startlist_starter&race_id=<span class="blue">robis ID etapy</span></code></li>
            <li>Startovní listina podle oddílů - <code>https://rob-is.cz/export/?type=pdf&name=startlist_clubs&race_id=<span class="blue">robis ID etapy</span></code></li>
            <li>
              <a :href="`${BaseApiUrl}/ranking/national/${rankingYear}/export/?type=pdf`">Národní žebříček</a>
              - <code>https://rob-is.cz/api/ranking/national/<span class="blue">rok</span>/export/?type=pdf</code>
            </li>
            <li>
              <a :href="`${BaseApiUrl}/ranking/clubs/${rankingYear}/export/`">Žebříček oddílů</a>
              - <code>https://rob-is.cz/api/ranking/clubs/<span class="blue">rok</span>/export/</code>
            </li>
        </ul>

        <!-- <h4>XML:</h4>
        <p>Standard IOF 3.0</p>
            <ul>
                <li>Seznam přihlášených  - *URL SOUTĚŽE*/<code>ucastnici_xml/</code></li>
                <li>Startovka - *URL SOUTĚŽE*/<code>startlist_xml/</code></li>
            </ul> -->
          <h4>SI-Droid:</h4>
            <ul>
              <li><a :href="`${BaseUrl}/export/?type=csv&name=si_droid_all`">Seznam všech registrovaných</a></li>
              <li>Seznam přihlášených pro závod <code>https://rob-is.cz/export/?type=csv&name=si_droid_race&race_id=<span class="blue">robis ID etapy</span></code></li>
            </ul> 

        <h4>Livelox:</h4>
        <ul>
            <li>Seznam přihlášených v etapě - <code>https://rob-is.cz/export/?type=xml&name=startlist&race_id=<span class="blue">robis ID etapy</span></code></li>
            <li>Výsledky v etapě - <code>https://rob-is.cz/export/?type=xml&name=results&race_id=<span class="blue">robis ID soutežě</span></code></li>
        </ul>

        <h4>O-checklist:</h4>
        <ul>
            <li>Startovka - <code>https://rob-is.cz/export/?type=xml&name=startlist&race_id=<span class="blue">robis ID etapy</span></code></li>
        </ul>

        <h4>GPS ČSOS seznam:</h4>
        <ul>
            <li>GPS - <code>https://rob-is.cz/export/?type=csv&name=gps_csos&race_id=<span class="blue">robis ID etapy</span></code></li>
        </ul>



      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue';

const BaseUrl = ref(process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, '').replace(/\/api\/?$/, '')); // Odstraní "api/" a nadbytečná lomítka
const BaseApiUrl = ref(process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, ''));
const rankingYear = ref(new Date().getFullYear());

</script>

<style scoped>
ul {
  margin-left:40px;
}

.blue {
  color: rgb(83, 83, 255);
}

h4 {
  margin-top: 10px;
}

code {
  background-color: rgb(var(--v-theme-code));
  color: rgb(var(--v-theme-on-code));
  padding: 2px 4px;
  border-radius: 4px;
}


</style>
